// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2CfGg","title":"ClientInsurance_title__1103G","itemText":"ClientInsurance_itemText__Su3en"};